import * as ko from "knockout";
import {ItemViewModel} from "./item";
import {TType} from "./index";
import {IMessageData} from "../../../index";
import PromiseRequest from "../../../req/PromiseRequest";
import {storeObservable} from "../../../util/sessionstore";
import {REQUEST_THROTTLE} from "../../../constants";
import groupHtml from './group.html?raw';

export const template = groupHtml;

export class GroupViewModel {
    private readonly numItemsDefault: KnockoutObservable<number> = storeObservable('num.ruleset.derived.values')
    private readonly numItems: KnockoutObservable<number> = ko.observable(this.numItemsDefault())
    private readonly open: KnockoutObservable<boolean> = ko.observable(false)
    private readonly prefix: KnockoutObservable<string | null> = ko.observable(null)
    private readonly type: TType = 'group'
    readonly isReady: KnockoutObservable<boolean> = ko.observable(true);
    readonly items: KnockoutObservableArray<GroupViewModel | ItemViewModel> = ko.observableArray()
    readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    readonly title: KnockoutObservable<string | null> = ko.observable(null)
    req!: PromiseRequest

    private getTemplate(): string {
        return template
    }

    setPrefix(content: any) {
        this.prefix(content)
    }

    private suffix = ko.pureComputed(() => {
        return `[${this.items().length}]`
    })

    private getList = ko.pureComputed((): (GroupViewModel | ItemViewModel)[] => {
        return this.items().slice(0, this.numItems() ?? this.items().length)
    })

    dispose() {
        this.req?.abort()
    }
}
